module.exports = __webpack_public_path__ + "img/home_icon_nuantong_sel.b84380f8.png";